import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { DownOutlined, ArrowRightOutlined } from '@ant-design/icons';

// Tu lista de cruceros/yates de la flota
const cruceros = [
  { name: 'Tip Top II', href: '/tip-top-ii' },
  { name: 'Tip Top IV', href: '/tip-top-iv' },
  { name: 'Tip Top V', href: '/tip-top-v' },
  { name: 'Köln', href: '/koln' },
];

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="sticky top-0 z-50 w-full border-b border-slate-800 bg-slate-950/80 backdrop-blur-md text-white px-6 md:px-12 py-4">
      <div className="max-w-8xl mx-auto flex items-center justify-between">
        <div className="flex items-center gap-2 cursor-pointer group">
          <a href='/' className="font-black text-lg md:text-4xl tracking-widest uppercase bg-white bg-clip-text text-transparent">
            Tip Top Fleet
          </a>
          <img src="/favico.png" alt="Logo" className=' object-contain w-[60px]'/>
        </div>
        <div className="relative">
          <button
            onMouseEnter={() => setIsOpen(true)}
            onClick={() => setIsOpen(!isOpen)}
            className="flex items-center gap-2 px-4 py-2 rounded-xl bg-slate-900 border border-slate-800 hover:border-amber-500/50 transition-colors duration-300 group text-sm md:text-base font-medium"
          >
            <span>Nuestros Cruceros</span>
            <motion.div
              animate={{ rotate: isOpen ? 180 : 0 }}
              transition={{ duration: 0.2 }}
            >
              <DownOutlined className="text-xs text-slate-400 group-hover:text-amber-400 transition-colors" />
            </motion.div>
          </button>
          <AnimatePresence>
            {isOpen && (
              <motion.div
                initial={{ opacity: 0, y: 15, scale: 0.95 }}
                animate={{ opacity: 1, y: 0, scale: 1 }}
                exit={{ opacity: 0, y: 10, scale: 0.95 }}
                transition={{ duration: 0.2, ease: "easeOut" }}
                onMouseLeave={() => setIsOpen(false)}
                className="absolute right-0 mt-3 w-64 rounded-2xl border border-slate-800 bg-slate-900/95 p-2 shadow-2xl backdrop-blur-xl"
              >
                <div className="px-3 py-2 text-xs font-semibold uppercase tracking-wider text-amber-400/80 border-b border-slate-800 mb-1">
                  Explorar la Flota
                </div>

                <div className="flex flex-col gap-1">
                  {cruceros.map((crucero, index) => (
                    <motion.a
                      key={index}
                      href={crucero.href}
                      whileHover={{ x: 4 }}
                      className="flex items-center justify-between rounded-xl px-3 py-2.5 text-sm text-slate-300 hover:bg-slate-800 hover:text-white transition-colors group"
                    >
                      <span className="font-medium">{crucero.name}</span>
                      <ArrowRightOutlined className="text-xs text-transparent group-hover:text-amber-400 transition-all duration-300" />
                    </motion.a>
                  ))}
                </div>
              </motion.div>
            )}
          </AnimatePresence>
        </div>

      </div>
    </nav>
  );
}